export default __webpack_public_path__ + "static/media/refreshIcon.52a2678f.svg";